import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ErrorlogService } from '@services/errorlog/errorlog.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-errorlog-detail',
    templateUrl: './errorlog-detail.component.html',
    styleUrls: ['./errorlog-detail.component.scss'],
    providers: [ErrorlogService],
    standalone: false
})
export class ErrorlogDetailComponent implements OnInit {

  isLoading: boolean;

  title = 'Error: ';

  error: Models.Error;

  constructor(
    private errorLogService: ErrorlogService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.errorLogService.get(this.route.snapshot.params['id']).then(error => {
      this.error = error;
      this.isLoading = false;
    });
  }

}
